export default __webpack_public_path__ + "static/media/2023-brestovat-pavaj.1e3854c0.jpg";